var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"LoadingOverlay"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoadingOverlay__text"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-fw"}),_vm._v(" Loading...\n    ")])
}]

export { render, staticRenderFns }